import React, { useEffect, useState } from "react";
import {
  getBrowserInfo,
  isTokenValid,
  isUserVerified,
} from "../../utils/helper";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader } from "../common/Loader";
import { getLoginUserDetails, userSettingData } from "../../utils/tools";
import CountrySelect from "../common/CountrySelect";
import { Checkbox } from "antd";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [animation, setAnimation] = useState(true);
  const [userDetails, setUserDetails] = useState({
    email: "",
    password: "",
    country: undefined,
    migration: false,
  });
  const [loading, setLoading] = useState(false);
  const [checkHidden, setCheckHidden] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);
  let token = queryParameters.get("token");
  let role = queryParameters.get("role");
  let id = queryParameters.get("id");
  let path = queryParameters.get("path");
  let country = queryParameters.get("country");

  const getRegionFromLanguage = () => {
    const language = navigator.language || navigator.userLanguage;
    if (language.includes("AE"))
      setUserDetails({ ...userDetails, country: "UAE" });
    else setUserDetails({ ...userDetails, country: "KSA" });
  };

  useEffect(() => {
    getRegionFromLanguage();
  }, []);

  const checkTwoFactorAuthenticated = (response) => {
    // let browserInfo = getBrowserInfo();
    // let verified = isUserVerified(
    //   sessionStorage.getItem("userId"),
    //   browserInfo.browser,
    //   browserInfo.os
    // );
    // if (
    //   response["2fa_status"] == 1 &&
    //   !verified &&
    //   response.role === "customer"
    // ) {
    //   setTimeout(() => {
    //     navigate("/signin/two-factor", {
    //       state: {
    //         country: userDetails.country,
    //       },
    //     });
    //   }, 1000);
    //   localStorage.setItem("userToken", response.token);
    //   localStorage.setItem("role", response.role);
    //   localStorage.setItem(
    //     "isTwoFactorEnabled",
    //     response["2fa_status"] == 1 ? true : false
    //   );
    //   await getUserDetails();
    //   checkTwoFactorAuthenticated(response);
    // } else
      if (response.role === "customer") {
      if (userDetails.country === "UAE") {
        window.location.href = `https://governify.uae.tasc360.com/?role=customer&token=${response.token}&country=${userDetails.country}`;
      } else {
        window.location.href = `https://governify.ksa.tasc360.com/?role=customer&token=${response.token}&country=${userDetails.country}`;
      }
    } else {
      if (userDetails.country === "UAE") {
        window.location.href = `https://governify.uae.tasc360.com/admin?role=admin&token=${response.token}&country=${userDetails.country}`;
      } else {
        window.location.href = `https://governify.ksa.tasc360.com/admin?role=admin&token=${response.token}&country=${userDetails.country}`;
      }
    }
  };

  const handleSubmit = async () => {
    let payload = JSON.stringify({
      email: userDetails.email,
      password: userDetails.password,
      domain: "governify",
      country_code: userDetails.country === "UAE" ? "UAE" : "KSA",
      backendbaseurl:
        userDetails.country === "UAE"
          ? "https://onboardifyapi.uae.tasc360.com"
          : "https://onboardifyapi.ksa.tasc360.com",
      is_migration: userDetails.migration,
    });

    try {
      setLoading(true);
      const baseUrl =
        userDetails.country === "UAE"
          ? "https://onboardifyapi.uae.tasc360.com/commom-login"
          : "https://onboardifyapi.ksa.tasc360.com/commom-login";
      const domainUrl = userDetails.country === "UAE"
          ? "https://onboardifyapi.uae.tasc360.com"
          : "https://onboardifyapi.ksa.tasc360.com";
      const response = await fetch(baseUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Specify the content type
        },
        body: payload, // Convert payload to JSON string
      });

      
      
      if (!response.ok) {
        // Handle HTTP errors
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const newResponse = await response.json();
      console.log('newResponse', newResponse);
      // return;

      if (newResponse.status && !newResponse.hasOwnProperty("status_code")) {
        toast.success("Logged In Successfull.");
        sessionStorage.setItem("token", newResponse.token);
        sessionStorage.setItem("role", newResponse.role);
        sessionStorage.setItem(
          "isTwoFactorEnabled",
          newResponse["2fa_status"] == 1 ? true : false
        );

        await getLoginUserDetails(domainUrl);

        checkTwoFactorAuthenticated(newResponse);
      } else if (
        newResponse.status &&
        newResponse.hasOwnProperty("status_code") &&
        newResponse.status_code === "migrate"
      ) {
        toast.error(newResponse.message);
        setCheckHidden(true);
      } else {
        toast.error(newResponse.message);
      }
    } catch (err) {
      console.log(err, "error");
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const handleChangeUserDetails = (e, filter) => {
    setUserDetails({ ...userDetails, [filter]: e.target.value });
  };

  const checkEmailIsFilledAndValid = () => {
    const email = userDetails.email;
    const emailRegex = /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,6}$/;
    if (email && emailRegex.test(email)) {
      return false;
    }
    return true;
  };

  const checkPasswordIsFilledValid = () => {
    const password = userDetails.password;
    if (password.length > 5) {
      return false;
    }
    return true;
  };

  const adminLogin = async () => {
    let status = isTokenValid(token);
    if (status.valid) {
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("role", role);
      await getLoginUserDetails();
      await userSettingData();
      // if (id && role === "customer") {
      if (role === "customer") {
        if (id) {
          sessionStorage.setItem("requestId", id);
          sessionStorage.setItem("modalOpen", true);
          //   navigate(`/${path}`);
          if (country === "UAE") {
            window.location.href = `https://governify.uae.tasc360.com/?role=customer&token=${token}&country=${country}&requestId=${id}`;
          } else {
            window.location.href = `https://governify.ksa.tasc360.com/?role=customer&token=${token}&country=${country}&requestId=${id}`;
          }
        } else {
          if (country === "UAE") {
            window.location.href = `https://governify.uae.tasc360.com/?role=customer&token=${token}&country=${country}`;
          } else {
            window.location.href = `https://governify.ksa.tasc360.com/?role=customer&token=${token}&country=${country}`;
          }
        }
      } else {
        if (country === "UAE") {
          window.location.href = `https://governify.uae.tasc360.com/admin?role=admin&token=${token}&country=${country}`;
        } else {
          window.location.href = `https://governify.ksa.tasc360.com/admin?role=admin&token=${token}&country=${country}`;
        }
      }
    } else {
      navigate("/signin");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (!checkEmailIsFilledAndValid() && !checkPasswordIsFilledValid()) {
        handleSubmit();
      }
    }
  };

  const handleChangeCheckBoxMigration = (e) => {
    setUserDetails({ ...userDetails, migration: e.target.checked });
  };

  const checkMigration = () => {
    if (checkHidden) {
      if (userDetails.migration) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (token) {
      adminLogin();
    }
  }, [token]);

  useEffect(() => {
    setTimeout(() => {
      setAnimation(false);
    }, 300);
  }, []);

  if (token) {
    return <Loader />;
  }

  console.log('userDetails', userDetails);

  return (
    // <div className="inc-auth-container">
    <div
      className="inc-auth-container"
      style={{
        backgroundImage: userDetails.country === "UAE" ? `url(${process.env.PUBLIC_URL}/UAE.webp)` : `url(${process.env.PUBLIC_URL}/KSA.webp)`,
        backgroundSize: "100% 100%",
      }}
    >
      <div className="container auth-container text-center">
        {loading && <Loader />}
        <div className="cover-container w-100 h-100 pb-2 ">
          <div className="">
            <div className="animation-container" style={{ minHeight: "90px" }}>
              <div
                className={`header-heading1 ${
                  animation ? "animation-content" : ""
                } ff-ws `}
                style={{
                  transition: "transform 1s ease, opacity 2s ease",
                  fontSize: "50px",
                  fontWeight: "500",
                  color: "#015f83"
                }}
              >
                Governify
              </div>
            </div>
            {/* <div class="d-flex justify-content-center">
        <div class="alert alert-{{ status }}" style={{maxWidth:"400px"}}>
        </div>
      </div> */}
            <div
              className="form-container mx-auto"
              style={{ maxWidth: "440px" }}
            >
              <div>
                <div>
                  {/* <span className="inc-tasc-gradient-btn">TASC</span><span className="fs-48 ff-ws"> 360</span> */}
                  <img
                    src="/newlogo.svg"
                    alt="TASC logo"
                    style={{ maxWidth: "220px" }}
                  />
                </div>
                <div
                  className="fs-24 ff-ws mb-2 text-inc-tundora fw-600"
                  style={{ color: "#434343" }}
                >
                  Sign In
                </div>
              </div>
              <div className="form-auth">
                <form className="form-auth" onKeyDown={handleKeyDown}>
                  <input
                    placeholder="Email"
                    type="email"
                    value={userDetails.email}
                    onChange={(e) => handleChangeUserDetails(e, "email")}
                    style={{ background: "#e8f0fe" }}
                    className="input-customer-focus form-control"
                  />
                  <div className="input-group flex-nowrap" id="password-filled">
                    <input
                      className="form-control input-customer-focus"
                      id="input-password"
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      name="password"
                      value={userDetails.password}
                      onChange={(e) => handleChangeUserDetails(e, "password")}
                      style={{ background: "#e8f0fe" }}
                    />
                    <span
                      className="input-group-text fs-5 encrypted eye-icon-container"
                      style={{
                        cursor: "pointer",
                        borderRadius: "0 50px 50px 0px",
                      }}
                    >
                      {showPassword ? (
                        <i
                          className="bi bi-eye-fill"
                          onClick={() => setShowPassword(false)}
                        ></i>
                      ) : (
                        <i
                          className="bi bi-eye-slash-fill"
                          onClick={() => setShowPassword(true)}
                        ></i>
                      )}
                    </span>
                  </div>
                  <CountrySelect
                    formData={userDetails}
                    setFormData={setUserDetails}
                  />

                  {checkHidden && (
                    <div className="d-flex" style={{ gap: "5px" }}>
                      <div>
                        <Checkbox
                          onChange={handleChangeCheckBoxMigration}
                        ></Checkbox>
                      </div>
                      <span style={{ color: "#212529A6", textAlign: "left" }}>
                        By switching regions, data from your current region will
                        be hidden until you switch back. You can create and
                        track new requests in the new region.
                      </span>
                    </div>
                  )}

                  <button
                    id="login-button"
                    className="btn btn-newgradiant btn-to-link btn-secondary mt-4 d-flex align-items-center"
                    type="button"
                    style={{
                      border: "0",
                      borderRadius: "50px",
                      gap: "10px",
                      padding: "15px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",

                      transition: "0.5s",
                      height: "46px",
                      opacity:
                        checkEmailIsFilledAndValid() ||
                        checkPasswordIsFilledValid() ||
                        checkMigration() ||
                        userDetails.country === undefined
                          ? "0.65"
                          : "",
                    }}
                    onClick={handleSubmit}
                    disabled={
                      checkEmailIsFilledAndValid() ||
                      checkPasswordIsFilledValid() ||
                      checkMigration() ||
                      userDetails.country === undefined
                    }
                  >
                    <span
                      style={{
                        fontFamily: "Montserrat!important",
                        fontSize: "12px",
                        fontWeight: 700,
                      }}
                    >
                      Sign In
                    </span>
                    <span
                      className="icon-btn_track"
                      style={{ marginLeft: "10px" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z" />
                      </svg>
                    </span>
                  </button>

                  <div className="d-flex justify-content-between align-items-start w-100 mt-2">
                    <a
                      href="/forget-password"
                      className="fs-13"
                      style={{ color: "#434343" }}
                    >
                      Forgot Password?
                    </a>
                    <a
                      href="/signup"
                      className="fs-13"
                      style={{ color: "#434343" }}
                    >
                      Create New Account?
                    </a>
                  </div>
                  <div
                    className="mt-3 fs-13 ff-ws text-inc-tundora"
                    style={{ color: "grey" }}
                  >
                    <span
                      className="mt-3 fs-13 ff-ws text-inc-tundora"
                      style={{ margin: "3px 0px" }}
                    >
                      {" "}
                      Powered by TASC Outsourcing®
                    </span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer position="bottom-right" className="custom-toast" />
      </div>
    </div>
  );
};

export default Login;
